import React from 'react'
import '../Common/Style.css';

interface SuccessPopupProps {
  message: string
}

const SuccessPopup: React.FC<SuccessPopupProps> = ({ message }) => {


  return (
    <div className="alert alert-success gap-3 d-flex justify-content-center" style={{ position: "sticky", zIndex: "100", top: "10px" }} role="alert">
      <span>
        <img src={`${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}OTHER/1756905087319-a4f6796e-bddc-4356-a5ee-3fc3a3225cf9-check.png`} alt="" />
      </span>
      {(message && message.trim() !== "") ? message : "Changes have saved successfully!"}
    </div>

  )
}

export default SuccessPopup